import { render, staticRenderFns } from "./CurrencyViewCurrencyInfoCard.vue?vue&type=template&id=2b2ccd24"
import script from "./CurrencyViewCurrencyInfoCard.vue?vue&type=script&lang=js"
export * from "./CurrencyViewCurrencyInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports